export default "__VITE_ASSET__W7K1rg3y__"